import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-error-msg-dialog',
    templateUrl: './error-msg-dialog.component.html',
    styleUrls: ['./error-msg-dialog.component.css']
})
export class ErrorMsgDialogComponent implements OnInit {
    constructor(
        private dialogRef: MatDialogRef<ErrorMsgDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
    ) {}

    ngOnInit() {}

    close(): void {
        this.dialogRef.close();
    }
}
